import { ZodError } from "zod";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function isZodError<T = any>(err: unknown): err is ZodError<T> {
	return err !== undefined && err !== null && (err instanceof ZodError || (err as ZodError).name === "ZodError");
}
